import type { createUploadLink as UploadLinkType } from "apollo-upload-client";

import { getUploadLink as sharedUploadLink } from "@shared/data/client/links/uploadLink";
import { sharedRoutes } from "@shared/data/sharedRoutes";
import { isProduction } from "@shared/utils/fullscriptEnv/fullscriptEnv";

interface Params {
  baseUri?: string;
  isEmerson: boolean;
  isWordpress: boolean;
  uploadLinkOptions?: UploadLinkType.UploadLinkOptions;
}

const EE_ENTRYPOINT_URI = "/api/graphql/v2/emerson";
const FS_ENTRYPOINT_URI = "/api/graphql/v2";

const getUploadLink = ({
  baseUri = "",
  isEmerson,
  isWordpress,
  uploadLinkOptions = {},
}: Params) => {
  const getUri = () => {
    if (isEmerson && isWordpress) {
      return isProduction()
        ? sharedRoutes.external.wordpressGraphQL.production
        : sharedRoutes.external.wordpressGraphQL.staging;
    } else if (isEmerson) {
      return `${baseUri}${EE_ENTRYPOINT_URI}`;
    }

    return `${baseUri}${FS_ENTRYPOINT_URI}`;
  };

  if (isEmerson) {
    return sharedUploadLink({
      uri: getUri(),
      ...uploadLinkOptions,
    });
  }

  return sharedUploadLink({
    uri: getUri(),
    ...uploadLinkOptions,
  });
};

export { getUploadLink, FS_ENTRYPOINT_URI, EE_ENTRYPOINT_URI };
